<!--
 * @Author: your name
 * @Date: 2020-09-24 15:52:30
 * @LastEditTime: 2020-09-24 16:34:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/product-detail/component/ContainTags/index.vue
-->
<style scoped lang="sass">
.contain_tags
  font-size: 10px
  line-height: 12px
</style>

<template lang="pug">
.contain_tags(v-if="containTags ? containTags.length : false")
  span.title.b {{ containsLabel }}
  span.details.b(
    v-for="(item, index) in containTags"
    :key="item.id"
  )
    span.mark(v-if="index") {{ ', ' }}
    span.content {{ containTagText(item) }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t } from '@/utils/language'
import { decorateContainsTag } from '@/utils/seafoodOrigin'

@Component({
  props: {
    containTags: {
      type: Array,
    },
    // Seafood country-of-origin (backend sends it only for AU venues with a
    // Seafood product + value set). null/absent = old behavior.
    // 海鲜产地（仅澳洲 venue + 含 Seafood + 已设值时后端下发）。空/缺 = 老逻辑。
    seafoodOrigin: {
      type: String,
      default: null
    }
  },

  computed: {
    containsLabel() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('contains_label', 'Contains:') + ' '
    },
  },
})
class ContainTags extends Vue {
  /**
   * Display text for one contains-tag. The Seafood tag gets its
   * country-of-origin appended ("Seafood • {origin}") when the backend
   * provided one; every other tag is shown unchanged. Mirrors Spicy.
   * 单个 contains 标签的展示文字：海鲜标签在有产地时追加 "Seafood • {产地}"，
   * 其它标签原样显示。与 Spicy 一致。
   *
   * @param {String} item - one containTags entry
   * @returns {String}
   */
  containTagText(item) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return decorateContainsTag(item, this.seafoodOrigin)
  }
}

export default ContainTags
</script>
